import '@alltrails/bootstrapping/utils/instrumentation-client';
